import { Injectable } from '@angular/core';
declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  ajsService: any;

  constructor() {

    if ((window as any).angular) {
      const element = document.querySelectorAll('div[ui-view]');
      const injector = angular.element(element).injector();

      this.ajsService = injector.get('$location');
    }
  }

  /**
   * go to URL. This will need to call the Angular 2+ Location.go when upgraded
   */
  go(path: string) {
    return this.ajsService.path(path);
  }
}
